import DynamicFormulaService from "./services/dynamicFormulaService";
import {toast} from "react-toastify";
import {makeAutoObservable} from "mobx";

export class DynamicFormulaStore {

    /** @type {Formula[]}*/
    allSumFormulas = [];

    /**@type DisciplineForSumFormula*/
    disciplinesForSumFormula = [{discipline_id: 0, discipline_name: ''}];

    constructor() {
        makeAutoObservable(this);
    }

    // Добавление дисциплины к гибкой суммарной формуле.
    async addDisciplineFormula(ageGroupId, disciplineId, formulaId) {
        const result = await DynamicFormulaService.addDisciplineFormula(ageGroupId, disciplineId, formulaId);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, дисциплина не добавлена!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas = this.allSumFormulas.map(formula => {
                if (formula.formula_id === formulaId) {
                    return {
                        ...formula,
                        discipline_results: [
                            ...formula.discipline_results,
                            {
                                discipline_result_id: result?.data?.discipline_result_id,
                                discipline_result_name: result?.data?.discipline_short
                            }
                        ]
                    };
                }
                return formula;
            });
            this.toastSuccess("Дисциплина успешно добавлена!");
        }
    }

    // Создание новой суммарной формулы.
    async createSumFormula(formulaName) {
        const result = await DynamicFormulaService.createSumFormula(formulaName);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, формула не создана!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas.push({
                formula_id: result?.data?.formula_id,
                formula_name: result?.data?.formula_name,
                discipline_results: []
            });
            this.toastSuccess("Формула успешно создана!");
        }
    }

    // Удаление дисциплины из гибкой суммарной формулы.
    async deleteDisciplineFormula(disciplineResultId) {
        const result = await DynamicFormulaService.deleteDisciplineFormula(disciplineResultId);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, дисциплина не удалена!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas = this.allSumFormulas.map(formula => ({
                ...formula,
                discipline_results: formula.discipline_results.filter(
                    result => result.discipline_result_id !== disciplineResultId
                )
            }));
            this.toastSuccess("Дисциплина успешно удалена!");
        }
    }

    // Удаление суммарной формулы.
    async deleteSumFormula(formulaId) {
        const result = await DynamicFormulaService.deleteSumFormula(formulaId);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, фомула не удалена!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas = this.allSumFormulas.filter(item => item.formula_id !== formulaId);
            this.toastSuccess("Формула успешно удалена!");
        }
    }

    async getAllSumFormula(ageGroupId) {
        const result = await DynamicFormulaService.getAllSumFormula(ageGroupId);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, нет данных!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas = result?.data?.formulas;
        }
    }

    // Получение списка дисциплин для суммарной формулы.
    async getDisciplineForSumFormula() {
        const result = await DynamicFormulaService.getDisciplineForSumFormula();

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, нет данных!';
            }
            this.toastError(message);
        } else {
            this.disciplinesForSumFormula = result?.data?.disciplines;
        }
    }

    // Переименование суммарной формулы.
    async renameSumFormula(formulaId, formulaName) {
        const result = await DynamicFormulaService.renameSumFormula(formulaId, formulaName);

        if (result?.data.status && result?.data.status === 'error') {
            let message = result?.data.message;
            if (!message) {
                message = 'Ошибка, нет данных!';
            }
            this.toastError(message);
        } else {
            this.allSumFormulas = this.allSumFormulas.map(item => item.formula_id === formulaId ? {
                ...item, formula_name: formulaName
            } : item);
            this.toastSuccess("Формула успешно переименована!");
        }
    }

    toastSuccess(message) {
        toast.success(message, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    toastError(message) {
        toast.error(message, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
}